/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Faq_EyebrowInputs */

const en_price_page_faq_eyebrow = /** @type {(inputs: Price_Page_Faq_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions`)
};

const pl_price_page_faq_eyebrow = /** @type {(inputs: Price_Page_Faq_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pytania`)
};

/**
* | output |
* | --- |
* | "Questions" |
*
* @param {Price_Page_Faq_EyebrowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_faq_eyebrow = /** @type {((inputs?: Price_Page_Faq_EyebrowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Faq_EyebrowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_faq_eyebrow(inputs)
	return en_price_page_faq_eyebrow(inputs)
});